const testimonialsSection = document?.querySelectorAll(".testimonials-section");

testimonialsSection?.forEach((item) => {
  const sliderEl = item?.querySelector(".keen-slider");
  if (sliderEl) {
    const slider = new KeenSlider(sliderEl);
    const prevBtn = item?.querySelector(".prev");
    const nextBtn = item?.querySelector(".next");
    prevBtn?.addEventListener("click", function () {
      slider.prev();
    });
    nextBtn?.addEventListener("click", function () {
      slider.next();
    });
  }
});
